import { actionGenerator, IReduxAction } from '../../../actionGenerator';

export const LOAD_BET_POSITION_FAIL = 'BET_POSITION :: LOAD_BET_POSITION_FAIL';

export type TLoadBetPositionFailAction = IReduxAction<typeof LOAD_BET_POSITION_FAIL>;

export const loadBetPositionFail = actionGenerator<typeof LOAD_BET_POSITION_FAIL>(LOAD_BET_POSITION_FAIL);
